import styles from "./hand-swipe-animation.module.scss";

const HandSwipeAnimation = ({
    visible = false
}) => {
    return (
        visible && (
            <div className={styles["swipe"]}>
                <div className={styles["path-hand"]}></div>
                <div className={styles["hand-icon"]}></div>
            </div>
        )
    );
};

export default HandSwipeAnimation;